import {
  useGetList, useCreateList, useGetDepartment,
} from '@vlabs/api/artemy/client';
import type { CreatedList, DepartmentId, ListId } from '@vlabs/api/artemy/model';

function useDuplicateList(listId: ListId) {
  const { data: list } = useGetList(listId);
  const duplicateList = useCreateList();
  const { data: ownerDepartment } = useGetDepartment(list?.owner_department ?? '', {
    query: { enabled: !!list?.owner_department },
  });

  return async (
    formValues: { user_data: string; departmentId: DepartmentId },
  ): Promise<CreatedList> => duplicateList.mutateAsync({
    data: {
      user_data: formValues.user_data,
      owner_department: formValues.departmentId,
      is_active: !!list?.is_active,
      is_open: !!ownerDepartment?.lists?.find(({ list_id }) => list_id === listId)?.open,
    },
  });
}

export { useDuplicateList };
